import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CountersignVerificationData } from '../dtos/countersign-verification-data.dto';
import { DocumentCountersignDTO } from '../dtos/document-countersign.dto';

@Injectable({
  providedIn: 'root',
})
export class DocumentCountersignService {
  constructor(private readonly httpClient: HttpClient) {}

  getDocumentCountersignInfo(
    organizationId: string,
    studyId: string,
    documentId: string,
    versionNo: number,
  ): Observable<DocumentCountersignDTO[]> {
    return this.httpClient.get<DocumentCountersignDTO[]>(
      `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/document/${documentId}/version/${versionNo}/countersign-info`,
    );
  }

  verifyCountersignPassword(organizationId: string, studyId: string, verificationData: CountersignVerificationData) {
    return this.httpClient.post(
      `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/countersign/verify-password`,
      verificationData,
    );
  }

  countersignDocument(
    organizationId: string,
    studyId: string,
    documentId: string,
    versionNo: number,
    documentCountersign: DocumentCountersignDTO,
  ): Observable<DocumentCountersignDTO> {
    return this.httpClient.post<DocumentCountersignDTO>(
      `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/document/${documentId}/version/${versionNo}/countersign`,
      documentCountersign,
    );
  }

  // This method is only used with docusign integration
  sentDocumentToCountersign(
    organizationId: string,
    studyId: string,
    meetingId: string,
    discussionItemId: string | null, // Discussion Item can be null
    decisionId: string | null, // Decision can be null
    taskId: string | null, // Task can be null
    userId: string | null, // User can be null
    documentId: string,
    versionNo: number,
  ): Observable<void> {
    let endpointUrl = `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}`;
    if (userId) {
      endpointUrl += `/user/${userId}`;
    } else if (decisionId) {
      endpointUrl += `/meeting/${meetingId}/discussion-item/${discussionItemId}/decision/${decisionId}`;
    } else if (discussionItemId) {
      endpointUrl += `/meeting/${meetingId}/discussion-item/${discussionItemId}`;
    } else if (meetingId) {
      endpointUrl += `/meeting/${meetingId}`;
    }
    if (taskId) {
      endpointUrl += `/task/${taskId}`;
    }

    return this.httpClient.post<void>(`${endpointUrl}/document/${documentId}/version/${versionNo}/sent-for-sign`, {});
  }
}
